import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2yavxh8gni: FaireBrandEntity = {
  token: "b_2yavxh8gni",
  type: "brand",
  name: "Wonder Valley",
  avatarUrl:
    "https://cdn.faire.com/fastly/6b5430b8309a0f0803003f80353dad8cde2a01e81bcf44bf8e957bc7726f2acd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/83c079c19b244650523eecd16f300237c0e84b7cdacd3f8445c44b854822ed8f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6b5430b8309a0f0803003f80353dad8cde2a01e81bcf44bf8e957bc7726f2acd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/83c079c19b244650523eecd16f300237c0e84b7cdacd3f8445c44b854822ed8f.jpeg",
  location: "Joshua Tree, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "California Grown & Family Owned\nWonder Valley started in 2014 around one product: California extra virgin olive oil.  Delicious, timeless, and potent with health benefits - our oil is used both for your kitchen and as a key ingredient in a growing line of skin & haircare. Since then, this bottle has became a cult-favorite for our disruptive packaging, strong branding, and exceptional extra virgin olive oil.\nWonder Valley is body, bath, and hair care for people who don’t want a 12-step routine. For those who value quality over quantity. For those who want fewer, better essentials. Wonder Valley emerged from a deep reverence for natural beauty, the luxury of time, nature, and simple ritual, and uncompromising quality.  Proudly family-owned, founded by Alison & Jay Carroll.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:23.001Z",
    importedBy: "entity-db-cli",
  },
};
